import {type List} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type Employee} from 'web-app/react/entities/employees/model';

const domain = 'MANAGE_EMPLOYEE_RIGHTS';

export const {
    action: fetchEmployees,
    success: fetchEmployeesSuccess,
    failed: fetchEmployeesFailed,
} = createAction(
    `${domain}/FETCH_DATA`,
    (institutionId: string) => ({institutionId}),
    (employees: List<Employee>, institutionId: string) => ({employees, institutionId}),
);

export const {action: filterByRole} = createAction(`${domain}/FILTER_BY_ROLE`, (roleId: string) => ({roleId}));
